var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4,
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1946 3.78057C13.6523 1.40648 10.3477 1.40648 9.80538 3.78057C9.58846 4.73011 8.5281 5.18685 7.71507 4.6792L7.5198 4.55727C5.53034 3.31504 3.28189 5.70495 4.55727 7.70202C5.07833 8.51792 4.6408 9.61703 3.71071 9.82477C1.42976 10.3342 1.42976 13.6658 3.71071 14.1752C4.6408 14.383 5.07833 15.4821 4.55727 16.298C3.28189 18.295 5.53034 20.685 7.5198 19.4427L7.71508 19.3208C8.5281 18.8132 9.58846 19.2699 9.80538 20.2194C10.3477 22.5935 13.6523 22.5935 14.1946 20.2194C14.4115 19.2699 15.4719 18.8132 16.2849 19.3208L16.4802 19.4427C18.4697 20.685 20.7181 18.295 19.4427 16.298C18.9217 15.4821 19.3592 14.383 20.2893 14.1752C22.5702 13.6658 22.5702 10.3342 20.2893 9.82477C19.3592 9.61703 18.9217 8.51792 19.4427 7.70202C20.7181 5.70495 18.4697 3.31505 16.4802 4.55727L16.2849 4.6792C15.4719 5.18685 14.4115 4.73011 14.1946 3.78057Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.b020874bdb2de4415f4654068c71a39b.svg";
export { ForwardRef as ReactComponent };